import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App, { OfflineBanner } from './App';
import reportWebVitals from './reportWebVitals';
import { adminAppRoutePath } from './utils/adminAppRoutePath';

// /order/* 진입 시 온라인 주문 청크를 React 마운트 직전에 선로드(lazy와 동일 청크)
if (typeof window !== 'undefined' && window.location.pathname.startsWith('/order/')) {
  void import(/* webpackChunkName: "online-order-page", webpackPrefetch: true */ './pages/online-order/OnlineOrderPage');
}

const adminRouteEarly =
  typeof window !== 'undefined' ? adminAppRoutePath(window.location.pathname) : '/';
if (adminRouteEarly === '/quotes') {
  void import(
    /* webpackChunkName: "quotes-contracts-page", webpackPrefetch: true */ './pages/admin/QuotesContractsPage',
  );
}

if (typeof (window as any).__cancelLoadFallback === 'function') {
  (window as any).__cancelLoadFallback();
}

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('Missing #root element');
}

/** index.html bootstrap markup must not stay in #root once React mounts. */
rootEl.replaceChildren();

const root = ReactDOM.createRoot(rootEl);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <OfflineBanner />
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);

/** Slow networks: inline HTML may show #app-load-fallback before main.js runs; remove it once React mounted. */
function hideAppLoadFallback() {
  const fb = document.getElementById('app-load-fallback');
  if (fb) fb.remove();
}
window.setTimeout(hideAppLoadFallback, 0);

reportWebVitals();
